/*
 * list.tsx
 * This Service Partners list Component is used for representing all the saved partners in list Form.
 */
// Import necessary modules and components
import useFetch from "../../../hooks/useFetch";
import { useContext, useEffect, useRef, useState } from "react";
import { PageHeader } from "../../../components/page-header/page-header";
import useToast from "../../../hooks/useToast";
import Utils from "../../../utils";
import {
  TDropdownOptions,
  TPrivilege,
  TResponseModel,
} from "../../../types/config";
import { TFilterModel } from "../../../types/config";
import DateUtils from "../../../utils/date";
import {
  eAMCAPPROVALSTATUS,
  eColumnConfigKeys,
  eMAPPED_DEALER_VIEW,
  eOTHERREQUESTTYPE,
  ePrivileges,
  eResultCode,
  eRoles,
  eTICKETSTATUSUNIQUEID,
  eTICKETTYPE,
} from "../../../utils/enum";
import styles from "./ticket.module.css";
import { ToastOpen, ToastType } from "../../../state/toast/slice";
import {
  dateOnlyFormat,
  defaultFilterParams,
  requestType,
  STAKE_HOLDERS,
} from "../../../utils/constants";
import {
  Badge,
  Button,
  Drawer,
  Input,
  Tag,
  Table,
  TableColumnsType,
  Tooltip,
  Form,
  Row,
  Col,
  Select,
  TableColumnType,
  Space,
  InputRef,
  DatePicker,
} from "antd";
import { TDealer, TTicket } from "../../../types";
import { useNavigate } from "react-router-dom";
import {
  AddEditDealerPartnerMapping,
  DeleteTicket,
  GetCustMappedPartnerList,
  GetSpecificDealerData,
  GetTicketList,
  GetTicketTypeCount,
  GetUserList,
  ReassignTicket,
} from "../../../utils/api.constant";
import { UserContext } from "../../../context";
import {
  CalendarOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FilterFilled,
  FilterOutlined,
  IdcardOutlined,
  MoreOutlined,
  OrderedListOutlined,
  ReloadOutlined,
  SearchOutlined,
  SettingOutlined,
  ShoppingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import ColumnManager from "../../../components/configurable-columns";
import {
  FilterDropdownProps,
  TablePaginationConfig,
} from "antd/es/table/interface";
import GenericPopover from "../../../components/pop-over";
import ActionCard from "../../../components/actionCard/actionCard";
import CustomDrawer from "../../../components/drawer";
import AMCApproverForm from "./amc-form";
import CustomModal from "../../../components/modal";
import ServiceRequestHistory from "./ticket-history";
import dayjs, { Dayjs } from "dayjs";
import DealerDetails from "./dealer-details";
import ExportToCSV from "../../../components/exporttocsv/ExportToCsv";
import { getStatusColor } from "../../../utils/ticket-status";
import BulkUploadTicketForm from "./bulk-upload-form";
import CustomDropdown from "../../../components/custom-dropdown/custom-dropdown";
import SparePartsTable from "./spare-approval";
import WarrantyApproverForm from "./warranty-form";
import { ColumnConfigManager } from "../../../utils/column-management";
import MappingForm from "../data-management/dealer/eng-mappingForm";
import ShipmentUpdateForm from "./shipment-status-form";
import Highlighter from "react-highlight-words";
import utils from "../../../utils";
import { filter } from "lodash";

type TTicketStatus = {
  label: string;
  statusUniqueId: string;
  count: number;
  type?: number;
};

const { RangePicker } = DatePicker;

// Define the User Component to display the list of dealers
export default function TicketDataList() {
  // State and hooks initialization
  const { post } = useFetch();
  const [isSpareApprovalModalVisible, setSpareApprovalModalVisible] =
    useState<boolean>(false);
  const [isReassignOpen, setReassignOpen] = useState<boolean>(false);
  const [primaryEngineer, setPrimaryEngineer] = useState<TDropdownOptions>();
  const [secondaryEngineer, setSecondaryEngineer] =
    useState<TDropdownOptions>();
  const [serviceCordinator, setServiceCordinator] =
    useState<TDropdownOptions>();
  const [serviceEscalation, setServiceEscalation] =
    useState<TDropdownOptions>();

  const [servicePartnerOptions, setServicePartnerOptions] = useState<
    TDropdownOptions[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<TTicket[]>([]);
  const formatDate = (date: Date) => date.toISOString().split("T")[0];

  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);

  const [filterParams, setFilterParams] = useState<TFilterModel>({
    ...defaultFilterParams,
    fromDate: formatDate(thirtyDaysAgo),
    toDate: formatDate(today),
  });

  const [ticketStatus, setTicketStatus] = useState<TTicketStatus[]>([]);
  const navigate = useNavigate();
  const { onShowToast } = useToast();
  const [globalsearchText, setGlobalSearchText] = useState("");
  const context: any = useContext(UserContext);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState<TTicket | null>(null);
  const [isModalVisible, setModalVisible] = useState<boolean>(false);
  const [isAssignMappingFormVisible, toggleAssignMappingForm] =
    useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isDealerModalVisible, setDealerModalVisible] =
    useState<boolean>(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);
  type DataIndex = keyof TDealer;
  const [dealerDetails, setDealerDetails] = useState<TDealer | null>(null);
  const [activeFilters, setActiveFilters] = useState<Record<string, any>>({});

  const commonSorter = (a: any, b: any, key: string) => {
    const valueA = a[key] as string;
    const valueB = b[key] as string;
    return valueA?.localeCompare?.(valueB);
  };

  useEffect(() => {
    updateColumns();
  }, [context?.user, filterParams.ticketViewId]);

  useEffect(() => {
    handleResetAll();
  }, [filterParams.ticketViewId]);

  console.log(context);

  // useEffect(() => {
  //   let type = getActiveTab() * 1;
  //   setFilterParams({ ...defaultFilterParams, ticketViewId: type });
  // }, [ticketStatus]);

  const fetchSpecificDealer = async (id: number) => {
    try {
      const payload = {
        data: {
          id: id,
        },
      };

      const response: TResponseModel = await post(
        GetSpecificDealerData,
        payload,
      );
      if (response) {
        const { data, dataResponse } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode === eResultCode.SUCCESS) {
          const {
            installationDate,
            amcFromDate,
            amcToDate,
            customerName,
            isAMCActive,
            lastPM,
            warrantyDate,
            ...restData
          } = data;
          setDealerDetails({
            ...restData,
            installationDate: installationDate ? dayjs(installationDate) : null,
            amcFromDate: amcFromDate ? dayjs(amcFromDate) : null,
            amcToDate: amcToDate ? dayjs(amcToDate) : null,
            lastPM: lastPM ? dayjs(lastPM) : null,
            warrantyDate: warrantyDate ? dayjs(warrantyDate) : null,
            customerName: customerName,
            isAMCActive,
          });
          setDealerModalVisible(true);
        } else {
          onShowToast({
            type: ToastType.error,
            title: <CloseOutlined />,
            position: ToastOpen.centerTop,
            content: description,
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  // Helper to generate unique filter options

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
  ): TableColumnType<TTicket> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder="Filter by keyword"
          prefix={
            <SearchOutlined
              style={{ color: "rgba(0,0,0,.45)", marginRight: 4 }}
            />
          } // Adds and spaces the search icon
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{
            marginBottom: 8,
            display: "flex",
            paddingLeft: "12px", // Ensure spacing for both icon and text
          }}
        />
        <Space style={{ display: "flex", justifyContent: "space-between" }}>
          {/* RESET FILTERS */}
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            type="link"
            size="small"
            style={{ width: 45 }}
          >
            Reset
          </Button>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 50 }}
          >
            Ok
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        style={{ color: filtered ? "var(--bs-primary)" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      (record as any)?.[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "var(--bs-primary)",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const initialColumns: TableColumnsType<TTicket> = [
    {
      title: "Ticket #",
      dataIndex: "serviceRequestNo",
      key: "serviceRequestNo",
      filterSearch: true,
      width: 100,
      onFilter: (value, record) =>
        (record.serviceRequestNo as string).includes(value as string),
      sorter: (a: TTicket, b: TTicket) =>
        commonSorter(a, b, "serviceRequestNo"),
      render: (_, ticket: TTicket) => (
        <span
          onClick={() =>
            Utils.isUserHasAccess(
              context?.user?.privilegeList,
              ePrivileges.EDITREQUEST,
            ) && onAddEdit((ticket?.id as number) || 0)
          }
          style={{ cursor: "pointer", color: "var(--bs-primary-dark)" }}
        >
          {ticket.serviceRequestNo}
        </span>
      ),
    },
    {
      title: "Customer",
      dataIndex: "customerName",
      key: "customerName",
      filterSearch: true,
      width: 150,
      sorter: (a: any, b: any) => commonSorter(a, b, "customerName"),
      onFilter: (value, record) =>
        (record.customerName as string)?.includes(value as string),
    },
    {
      title: "Dealer Name",
      dataIndex: "dealerName",
      key: "dealerName",
      ...getColumnSearchProps("dealerName"),
      width: 200,
      filterSearch: true,
      sorter: (a, b) => commonSorter(a, b, "dealerName"),
    },
    {
      title: "Dealer Code",
      dataIndex: "dealerCode",
      key: "dealerCode",
      width: 100,
      render: (_, ticket: TTicket) => ticket.dealerDetails?.dealerCode,
      sorter: (a: any, b: any) =>
        commonSorter(a.dealerDetails, b.dealerDetails, "dealerCode"),
      filterSearch: true,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder="Filter by code"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => clearFilters && clearFilters()}
              type="link"
              size="small"
            >
              Reset
            </Button>
            <Button type="primary" onClick={() => confirm()} size="small">
              Ok
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <FilterFilled
          style={{ color: filtered ? "var(--bs-primary)" : undefined }}
        />
      ),
      onFilter: (value, record) =>
        record.dealerDetails?.dealerCode
          ?.toString()
          ?.toLowerCase()
          ?.includes((value as string).toLowerCase()) ?? false,
    },
    {
      title: "Ticket Type",
      dataIndex: "ticketTypeName",
      key: "ticketTypeName",
      width: 150,
      sorter: (a: any, b: any) => commonSorter(a, b, "ticketTypeName"),
      filterSearch: true,
      onFilter: (value, record) =>
        (record.ticketTypeName as string)?.includes(value as string),
    },
    {
      title: "Issue",
      dataIndex: "issueCatName",
      key: "issueCatName",
      width: 100,
      sorter: (a: any, b: any) => commonSorter(a, b, "issueCatName"),
      filterSearch: true,
      onFilter: (value, record) =>
        (record.issueCatName as string)?.includes(value as string),
    },
    {
      title: "Service Partner",
      dataIndex: "servicePartnerName",
      key: "servicePartnerName",
      filterSearch: true,
      width: 150,
      onFilter: (value, record) =>
        (record.servicePartnerName as string)?.includes(value as string),
      sorter: (a: any, b: any) => commonSorter(a, b, "servicePartnerName"),
    },
    {
      title: "Assigned To",
      dataIndex: "engineerName",
      key: "engineerName",
      width: 150,
      sorter: (a: any, b: any) => commonSorter(a, b, "engineerName"),
      filterSearch: true,
      onFilter: (value, record) =>
        (record.engineerName as string)?.includes(value as string),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      width: 100,
      sorter: (a: any, b: any) => commonSorter(a, b, "createdOn"),
      render: (ticketCreationDate: string) => {
        return DateUtils.format(ticketCreationDate, dateOnlyFormat);
      },
    },
    {
      title: "Status",
      key: "currentStatusName",
      dataIndex: "currentStatusName",
      width: 280,
      filterSearch: true,
      onFilter: (value, record) =>
        (record.currentStatusName as string)?.includes(value as string),
      render: (_, ticket: TTicket) => (
        <Tag color={getStatusColor(ticket.currentStatusName)}>
          {ticket.currentStatusName?.toLocaleUpperCase()}
        </Tag>
      ),
      sorter: (a: any, b: any) => commonSorter(a, b, "currentStatusName"),
    },
    {
      title: "Action",
      key: "actions",
      width: 100,
      align: "center",
      render: (ticket: TTicket) => (
        <GenericPopover
          placement="left"
          content={
            <div className="standardActionBox">
              {/* Dealers Row with Link */}

              {Utils.isUserHasAccess(
                context?.user?.privilegeList,
                ePrivileges.EDITREQUEST,
              ) ? (
                <ActionCard
                  text="Preview"
                  onClick={() => onAddEdit((ticket?.id as number) || 0)}
                >
                  <EyeOutlined />
                </ActionCard>
              ) : null}

              <ActionCard
                text="Timeline"
                onClick={() => {
                  setModalVisible(true);
                  setSelectedTicket(ticket);
                }}
              >
                <CalendarOutlined />
              </ActionCard>

              {/* To reassgin engineer on ticket, prevent this on specific ticket case */}

              {ticket.currentStatusUniqueId !== eTICKETSTATUSUNIQUEID.CLOSE &&
              ticket.currentStatusUniqueId !==
                eTICKETSTATUSUNIQUEID.FORCE_CLOSED &&
              ticket?.engineerId &&
              Utils.isUserHasAccess(
                context?.user?.privilegeList,
                ePrivileges.REASSIGNENGINEER,
              ) ? (
                <ActionCard
                  text="Re-assign Engineer"
                  onClick={() => {
                    setReassignOpen(true);
                    setSelectedTicket(ticket);
                  }}
                >
                  <UserOutlined />
                </ActionCard>
              ) : null}

              {(ticket.currentStatusUniqueId ===
                eTICKETSTATUSUNIQUEID.HOLD_SPARE_DEPENDENCY ||
                ticket.currentStatusUniqueId ===
                  eTICKETSTATUSUNIQUEID.HOLD_SPARES_APPROVAL_PENDING) &&
              Utils.isUserHasAccess(
                context?.user?.privilegeList,
                ePrivileges.VIEWSPARESPENDING,
              ) ? (
                <ActionCard
                  text="Review Spares"
                  onClick={() => {
                    setSpareApprovalModalVisible(true);
                    setSelectedTicket(ticket);
                  }}
                >
                  <SettingOutlined />
                </ActionCard>
              ) : null}
              {ticket?.ticketAMC?.amcApprovalStatus ===
                eAMCAPPROVALSTATUS.PENDING &&
              Utils.isUserHasAccess(
                context.user?.privilegeList,
                ePrivileges.AMCAPPROVER,
              ) ? (
                <CustomDrawer
                  size="default"
                  trigger={
                    <ActionCard text="AMC Review">
                      <EditOutlined />
                    </ActionCard>
                  }
                  component={AMCApproverForm}
                  componentProps={{
                    ticket: ticket,
                    onRefreshList: async () => {
                      await fetchTicketStatus(getActiveTab() * 1);
                      // setFilterParams({
                      //   ...filterParams,
                      //   ticketViewId: getActiveTab(),
                      // });
                      fetchRecordsInChunks();
                    },
                  }}
                  title="AMC Approver Form"
                />
              ) : null}

              {/* WARRANTY APPROVAL PENDING CASE -- ONLY FOR NEW INSTALLATION */}

              {/* ADDED :: ADD 2 CONDITION, FLAG SHOULD BE TRUE AND TICKET SHOULD BE CLOSE */}
              {ticket?.ticketType === eTICKETTYPE.NEWINSTALLATION &&
              !ticket?.isWarrantyApproved &&
              ticket?.currentStatusUniqueId === eTICKETSTATUSUNIQUEID.CLOSE &&
              Utils.isUserHasAccess(
                context.user?.privilegeList,
                ePrivileges.APPROVEWARRANTY,
              ) ? (
                <CustomDrawer
                  size="default"
                  trigger={
                    <ActionCard text="Warranty Review">
                      <ClockCircleOutlined />
                    </ActionCard>
                  }
                  component={WarrantyApproverForm}
                  componentProps={{
                    ticket: ticket,
                    onRefreshList: async () => {
                      await fetchTicketStatus(getActiveTab() * 1);
                      // setFilterParams({
                      //   ...filterParams,
                      //   ticketViewId: getActiveTab(),
                      // });
                      fetchRecordsInChunks();
                    },
                  }}
                  title="Warranty Approval Form"
                />
              ) : null}

              {/* Form to Establish the mapping for dealer and enginners  */}
              {ticket?.currentStatusUniqueId ===
                eTICKETSTATUSUNIQUEID.UNASSIGNED &&
              context.user?.stakeHolderName === STAKE_HOLDERS.SERVICEPARTNER &&
              Utils.isUserHasAccess(
                context.user?.privilegeList,
                ePrivileges.MAPDEALERENGG,
              ) ? (
                <ActionCard
                  text="Engineer Mapping"
                  onClick={() => {
                    toggleAssignMappingForm(true);
                    setSelectedTicket(ticket);
                  }}
                >
                  <SettingOutlined />
                </ActionCard>
              ) : null}

              {/* SPARE SHIPMENT STATUS UPDATE FORM */}

              {/* FORM WILL BE VISIBLE IF TICKET HAS STATUS HOLD AMC SPARE DEPENDENCY AND USER MUST HAVE ATLEAST ONE PRIVILIEGE EITHER SPARE REQUEST FORWARD OR SPAREDISPATCHED */}
              {/* IF TICKET IS WITH STATUS SPARE REQUEST FORWARDED THEN USER MUST HAVE PRIVILEGE OF SPARE DISPATCHED */}
              {((ticket.currentStatusUniqueId ===
                eTICKETSTATUSUNIQUEID.HOLD_AMC_SPARE_DEPENDENCY ||
                ticket.currentStatusUniqueId ===
                  eTICKETSTATUSUNIQUEID.SPARE_APPROVED) &&
                (Utils.isUserHasAccess(
                  context.user?.privilegeList,
                  ePrivileges.SERVICEREQUESTFORWARD,
                ) ||
                  Utils.isUserHasAccess(
                    context.user?.privilegeList,
                    ePrivileges.SPAREDISPATCHED,
                  ))) ||
              (ticket.currentStatusUniqueId ===
                eTICKETSTATUSUNIQUEID.SPARE_REQUEST_FORWARD &&
                Utils.isUserHasAccess(
                  context.user?.privilegeList,
                  ePrivileges.SPAREDISPATCHED,
                )) ? (
                <CustomDrawer
                  size="default"
                  trigger={
                    <ActionCard text="Shipment Update">
                      <ShoppingOutlined />
                    </ActionCard>
                  }
                  component={ShipmentUpdateForm}
                  componentProps={{
                    ticket: ticket,
                    onRefreshList: async () => {
                      await fetchTicketStatus(getActiveTab() * 1);
                      // setFilterParams({
                      //   ...filterParams,
                      //   ticketViewId: getActiveTab(),
                      // });
                      fetchRecordsInChunks();
                    },
                  }}
                  title="Spare Shipment Status Form"
                />
              ) : null}

              {Utils.isUserHasAccess(
                context.user?.privilegeList,
                ePrivileges.DELETETICKET,
              ) ? (
                <ActionCard
                  text="Delete"
                  onClick={() => {
                    setSelectedTicket(ticket);
                    setIsDeleteModalVisible(true);
                  }}
                >
                  <DeleteOutlined />
                </ActionCard>
              ) : null}
            </div>
          }
          icon={
            <MoreOutlined style={{ fontSize: "20px", cursor: "pointer" }} />
          }
        />
      ),
    },
  ];
  const [columns, setColumns] = useState(initialColumns);
  const [draftColumns, setDraftColumns] = useState(columns);

  const fetchData = async (
    offset: number,
    chunkSize: number,
    needTotalRows: boolean = false,
  ) => {
    if (filterParams?.ticketViewId || filterParams?.ticketViewId === 0) {
      try {
        // setIsLoading(true);
        const requestPayload = {
          data: {
            pageSize: chunkSize,
            currentPage: offset,
            isChunkAPICall: true,
            fromDate:
              filterParams.ticketViewId === eTICKETTYPE.CLOSE ||
              filterParams.ticketViewId === eTICKETTYPE.ALL
                ? filterParams.fromDate
                : null,
            toDate:
              filterParams.ticketViewId === eTICKETTYPE.CLOSE ||
              filterParams.ticketViewId === eTICKETTYPE.ALL
                ? filterParams.toDate
                : null,
            ticketViewId: filterParams.ticketViewId,
            isTotalCountRequest: needTotalRows ? 1 : 0,
          },
        };
        const response: TResponseModel = await post(
          GetTicketList,
          requestPayload,
        );
        const { dataResponse, data, filterModel } = response;
        if (dataResponse.returnCode === eResultCode.SUCCESS) {
          return needTotalRows ? filterModel?.totalRows : response;
        } else {
          onShowToast({
            type: ToastType.error,
            title: <CloseOutlined />,
            position: ToastOpen.centerTop,
            content: dataResponse.description,
          });
          // setIsLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        // setIsLoading(false);
      }
    }
  };

  const updateColumnFilters = (dataset: TTicket[]) => {
    const serviceRequestNo = utils.getUniqueFilters(
      dataset,
      "serviceRequestNo",
    );
    const customerName = utils.getUniqueFilters(dataset, "customerName");
    const issueCatName = utils.getUniqueFilters(dataset, "issueCatName");
    const servicePartnerName = utils.getUniqueFilters(
      dataset,
      "servicePartnerName",
    );
    const engineerName = utils.getUniqueFilters(dataset, "engineerName");
    const ticketTypeName = utils.getUniqueFilters(dataset, "ticketTypeName");
    const currentStatusName = utils.getUniqueFilters(
      dataset,
      "currentStatusName",
    );

    setColumns(
      (prevColumns) =>
        prevColumns.map((col) => {
          if (col.key === "serviceRequestNo") {
            return { ...col, filters: serviceRequestNo };
          }
          if (col.key === "customerName") {
            return { ...col, filters: customerName };
          }
          if (col.key === "ticketTypeName") {
            return { ...col, filters: ticketTypeName };
          }
          if (col.key === "issueCatName") {
            return { ...col, filters: issueCatName };
          }
          // if (col.key === "subIssueCatName") {
          //   return { ...col, filters: subissueCatName };
          // }
          if (col.key === "servicePartnerName") {
            return { ...col, filters: servicePartnerName };
          }
          if (col.key === "engineerName") {
            return { ...col, filters: engineerName };
          }
          if (col.key === "currentStatusName") {
            return { ...col, filters: currentStatusName };
          }
          return col;
        }) as any,
    );
  };

  const fetchTicketStatus = async (type: number) => {
    try {
      // setIsLoading(true);
      const requestPayload = {
        data: {},
      };

      const response: TResponseModel = await post(
        GetTicketTypeCount,
        requestPayload,
      );
      const { dataResponse, data } = response;
      if (dataResponse.returnCode === eResultCode.SUCCESS) {
        setTicketStatus(data);
        setFilterParams({
          ...filterParams,
          ticketViewId: type ? type : data[0]?.type,
        });
        // setIsLoading(false);
      } else {
        onShowToast({
          type: ToastType.error,
          title: <CloseOutlined />,
          position: ToastOpen.centerTop,
          content: dataResponse.description,
        });
        // setIsLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      // setIsLoading(false);
    }
  };

  const getActiveTab = () => {
    const newUrl = new URL(window.location.href);
    const queryParams = newUrl.searchParams;

    // Access the customerId and customerName query parameters
    let type: any = queryParams?.get("type");
    return type ? type : ticketStatus[0]?.type;
  };

  const fetchRecordsInChunks = async () => {
    const chunkSize = context?.chunkSize; // Fixed size for the first chunk
    setData([]);
    handleResetAll();
    setIsLoading(true);

    try {
      // Step 1: Fetch the total number of records
      const totalRecords = await fetchData(1, 1, true);
      setFilterParams({
        ...filterParams,
        totalRows: (totalRecords as number) || 0,
      });

      // Step 2: Fetch the first chunk
      const resp = await fetchData(1, chunkSize);
      const validFirstChunk = Array.isArray((resp as TResponseModel)?.data)
        ? (resp as TResponseModel)?.data
        : []; // Ensure valid data
      setData(validFirstChunk); // Set data to display the first chunk immediately
      updateColumnFilters((resp as TResponseModel).data);
      // Step 3: Determine the remaining records
      const remainingRecords =
        (totalRecords as number) > chunkSize
          ? (totalRecords as number) - chunkSize
          : 0;

      // Step 4: Fetch the remaining records
      if (remainingRecords > 0) {
        const response = await fetchData(2, remainingRecords);
        const validSecondChunk = Array.isArray(
          (response as TResponseModel)?.data,
        )
          ? (response as TResponseModel)?.data
          : []; // Ensure valid data

        // Combine the data from both chunks
        updateColumnFilters([...validFirstChunk, ...validSecondChunk]);
        setData((prevData) => [...prevData, ...validSecondChunk]);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching records:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on component mount and update
  useEffect(() => {
    if (context?.chunkSize) {
      fetchRecordsInChunks();
    }
  }, [
    filterParams?.ticketViewId,
    context?.chunkSize,
    filterParams.fromDate,
    filterParams.toDate,
  ]);

  useEffect(() => {
    selectedTicket?.customerId && fetchMappedPartners();
  }, [selectedTicket?.customerId]);

  const handleTicketDelete = async () => {
    try {
      const payload = {
        data: {
          id: selectedTicket?.id,
        },
      };

      const response: TResponseModel = await post(DeleteTicket, payload);
      if (response) {
        const { dataResponse, data } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode === eResultCode.SUCCESS) {
          onShowToast({
            type: ToastType.success,
            title: <CheckOutlined />,
            position: ToastOpen.centerTop,
            content: description,
          });
          fetchTicketStatus(getActiveTab() * 1);
          fetchRecordsInChunks();
        } else {
          onShowToast({
            type: ToastType.error,
            title: <CloseOutlined />,
            position: ToastOpen.centerTop,
            content: description,
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const fetchMappedPartners = async () => {
    try {
      const payload = {
        data: {
          customerId: selectedTicket?.customerId,
          pageSize: -1,
          currentPage: 1,
        },
      };

      const response: TResponseModel = await post(
        GetCustMappedPartnerList,
        payload,
      );
      if (response) {
        const { dataResponse, data } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode === eResultCode.SUCCESS) {
          setServicePartnerOptions(Utils.mapDropdownOptions(data));
        } else {
          onShowToast({
            type: ToastType.error,
            title: <CloseOutlined />,
            position: ToastOpen.centerTop,
            content: description,
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const onReassignEngineer = async () => {
    try {
      const payload = {
        data: {
          id: selectedTicket?.id,
          engineerId: primaryEngineer?.value,
          servicePartnerId: selectedTicket?.servicePartnerId,
        },
      };

      const response: TResponseModel = await post(ReassignTicket, payload);
      if (response) {
        const { dataResponse, data } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode === eResultCode.SUCCESS) {
          fetchTicketStatus(getActiveTab() * 1);
          fetchRecordsInChunks();
        } else {
          onShowToast({
            type: ToastType.error,
            title: <CloseOutlined />,
            position: ToastOpen.centerTop,
            content: description,
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  useEffect(() => {
    fetchTicketStatus(getActiveTab() * 1);
  }, []);

  const onAddEdit = (id: number) => {
    const formURL = id
      ? `/dashboard/ticket/form?id=${id}`
      : "/dashboard/ticket/form";
    navigate(formURL);
  };

  const filteredData = data.filter((item) => {
    // Filter based on active column filters
    const serviceRequestMatch =
      !activeFilters.serviceRequestNo ||
      activeFilters.serviceRequestNo.includes(item.serviceRequestNo);

    const customerNameMatch =
      !activeFilters.customerName ||
      activeFilters.customerName.includes(item.customerName);

    const dealerCodeMatch =
      !activeFilters.dealerCode ||
      activeFilters.dealerCode.includes(item.dealerDetails?.dealerCode);

    const ticketTypeMatch =
      !activeFilters.ticketTypeName ||
      activeFilters.ticketTypeName.includes(item.ticketTypeName);

    const issueMatch =
      !activeFilters.issueCatName ||
      activeFilters.issueCatName.includes(item.issueCatName);

    const servicePartnerMatch =
      !activeFilters.servicePartnerName ||
      activeFilters.servicePartnerName.includes(item.servicePartnerName);

    const engineerMatch =
      !activeFilters.engineerName ||
      activeFilters.engineerName.includes(item.engineerName);

    const statusMatch =
      !activeFilters.currentStatusName ||
      activeFilters.currentStatusName.includes(item.currentStatusName);

    // Special handling for OTHER ticket types if needed
    const otherTypeMatch =
      filterParams?.ticketViewId !== eTICKETTYPE.OTHER ||
      !activeFilters.otherTktReqType ||
      activeFilters.otherTktReqType.includes(item.otherTktReqType);

    // Handle warranty approval filter for installation tickets
    const warrantyMatch =
      !activeFilters.isWarrantyApproved ||
      activeFilters.isWarrantyApproved.includes(item.isWarrantyApproved);

    const searchMatch = Object.values(item).some((val) =>
      val?.toString()?.toLowerCase()?.includes(globalsearchText?.toLowerCase()),
    );

    // Return true only if all filters match
    return (
      serviceRequestMatch &&
      customerNameMatch &&
      dealerCodeMatch &&
      ticketTypeMatch &&
      issueMatch &&
      servicePartnerMatch &&
      engineerMatch &&
      statusMatch &&
      otherTypeMatch &&
      warrantyMatch &&
      searchMatch
    );
  });

  useEffect(() => {
    updateColumnFilters(filteredData);
  }, [activeFilters, data, filterParams.ticketViewId]);

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, any>,
    sorter: any,
  ) => {
    setActiveFilters(filters);
    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if ("dataIndex" in col) {
          return {
            ...col,
            filteredValue: filters[col.dataIndex as string] || null,
            sortOrder: col.dataIndex === sorter.field ? sorter.order : null,
          };
        }
        return col;
      }),
    );
  };

  const toggleColumn = (key: string) => {
    setDraftColumns((prevDraftColumns) =>
      prevDraftColumns.map((col) =>
        col.key === key ? { ...col, hidden: !col.hidden } : col,
      ),
    );
  };

  const handleDragEnd = (result: any) => {
    if (!result.destination) return;

    setDraftColumns((prevDraftColumns) => {
      const reorderedColumns = Array.from(prevDraftColumns);
      const [removed] = reorderedColumns.splice(result.source.index, 1);
      reorderedColumns.splice(result.destination.index, 0, removed);
      return reorderedColumns;
    });
  };

  const handleResetColumns = () => {
    setDraftColumns(initialColumns); // Reset staging state to initial state
  };

  const updateColumns = () => {
    // Clone the initial columns to avoid mutating the original array
    let updatedColumns = [...initialColumns];

    if (filterParams?.ticketViewId === eTICKETTYPE.OTHER) {
      // Remove the column with key 'ticketTypeName'
      updatedColumns = updatedColumns.filter(
        (column) =>
          column.key !== "ticketTypeName" && column.key !== "issueCatName",
      );

      // Add the "Request Type" column
      const additionalColumns = [
        {
          title: "Ticket Type",
          dataIndex: "ticketTypeName",
          key: "ticketTypeName",
          sorter: (a: TTicket, b: TTicket) =>
            (a?.otherTktReqType as number) - (b?.otherTktReqType as number),
          filterSearch: true,
          onFilter: (value: string, record: TTicket) =>
            (record.ticketTypeName as string)?.includes(value as string),
          width: "10%",
          render: (val: string, ticket: TTicket) => {
            return <span>{val}</span>;
          },
        },
        {
          title: "Target Closing Date",
          dataIndex: "targetClosingDate",
          key: "targetClosingDate",
          width: "10%",
          sorter: (a: any, b: any) => commonSorter(a, b, "targetClosingDate"),
          render: (targetClosingDate: string) => {
            return targetClosingDate
              ? DateUtils.format(targetClosingDate, dateOnlyFormat)
              : "N/A";
          },
        },
      ];

      updatedColumns.splice(4, 0, ...(additionalColumns as any)); // Insert at a specific index (e.g., 4)
    } else if (
      filterParams?.ticketViewId === eTICKETTYPE.NEWINSTALLATION ||
      filterParams?.ticketViewId === eTICKETTYPE.CLOSE
    ) {
      updatedColumns = updatedColumns.filter(
        (column) => column.key !== "issueCatName",
      );
      // Add the "warranty approval" column
      const warrantyApprovalColumn = {
        title: "Warranty Approval",
        dataIndex: "isWarrantyApproved",
        key: "isWarrantyApproved",
        filters: [
          { value: 1, text: "Approved" },
          { value: 0, text: "Pending" },
        ],
        sorter: (a: any, b: any) => commonSorter(a, b, "dealerName"),
        filterSearch: true,
        onFilter: (value: number, record: TTicket) =>
          record.isWarrantyApproved === value,
        width: 150,
        render: (val: number, ticket: TTicket) => {
          return ticket?.ticketType === eTICKETTYPE.NEWINSTALLATION ? (
            <Tag color={val ? "var(--bs-primary)" : "#DC3220"}>
              {val ? "Approved" : "Pending"}
            </Tag>
          ) : (
            <Tag color="#333333">N/A</Tag>
          );
        },
      };
      updatedColumns.splice(
        updatedColumns.length - 1,
        0,
        warrantyApprovalColumn as any,
      );
    } else {
      // Reset columns to initial state
      updatedColumns = [...initialColumns];
    }

    // Update the state with modified columns
    setColumns(updatedColumns);
    setDraftColumns(updatedColumns);
  };

  useEffect(() => {
    const savedColumns = ColumnConfigManager.loadConfig(
      eColumnConfigKeys.TicketList,
      initialColumns,
    );
    setColumns(savedColumns);
    setDraftColumns(savedColumns);
  }, []);

  const handleSaveColumns = () => {
    setColumns(draftColumns); // Apply changes to the final state
    setDrawerVisible(false); // Close the drawer
  };

  const visibleColumns = columns.filter((col) => !col.hidden);

  const exportHeaders = columns
    .filter(
      (column) =>
        column.key && (column?.title as string)?.toLowerCase() !== "action",
    )
    .map((column) => ({
      label: column.title,
      key: column.key,
    }));

  const exportData = data.map((ticket) => ({
    ...ticket,
    dealerCode: ticket?.dealerDetails?.dealerCode ?? "-",
    isWarrantyApproved: ticket?.isWarrantyApproved ? "Approved" : "Pending",
  }));

  const handleResetAll = () => {
    setActiveFilters({});
    setSearchText("");
    setColumns((prevColumns) =>
      prevColumns.map((col) => ({
        ...col,
        filteredValue: null,
        sortOrder: null,
      })),
    );
  };

  //Function to save the mapped engineers with dealer
  const onApplyConfiguration = async () => {
    try {
      const payload = {
        data: {
          dealerIdList: [
            {
              dealerId: selectedTicket?.dealerId,
              dealerCode: selectedTicket?.dealerDetails?.dealerCode,
            },
          ],
          servicePartnerId: selectedTicket?.servicePartnerId,
          customerId: selectedTicket?.customerId,
          primaryEngineerId: primaryEngineer?.value,
          secondaryEngineerId: secondaryEngineer?.value,
          serviceEscalationId: serviceEscalation?.value,
          serviceCordinatorId: serviceCordinator?.value,
        },
      };

      const response: TResponseModel = await post(
        AddEditDealerPartnerMapping,
        payload,
      );
      const { dataResponse } = response;
      const { description, returnCode } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        setPrimaryEngineer({ value: null, label: "" });
        setSecondaryEngineer({ value: null, label: "" });
        setServiceEscalation({ value: null, label: "" });
        setServiceCordinator({ value: null, label: "" });
        toggleAssignMappingForm(false);
        onShowToast({
          type: ToastType.success,
          title: <CheckOutlined />,
          position: ToastOpen.centerTop,
          content: description,
        });
        fetchTicketStatus(getActiveTab() * 1);
        fetchRecordsInChunks();
      } else {
        onShowToast({
          type: ToastType.error,
          title: <CloseOutlined />,
          position: ToastOpen.centerTop,
          content: description,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };

  const handleDeleteOk = async () => {
    if (selectedTicket) {
      await handleTicketDelete();
    }
    setSelectedTicket(null);
    setIsDeleteModalVisible(false);
  };

  const handleDeleteCancel = () => {
    setSelectedTicket(null);
    setIsDeleteModalVisible(false);
  };

  return (
    <>
      {ticketStatus?.length > 0 ? (
        <div
          className="statusTabs"
          style={{
            visibility: ticketStatus?.length > 0 ? "visible" : "hidden",
            fontFamily: "Montserrat-Medium",
            display: "flex",
            lineHeight: "1.5rem",
            fontSize: "14px",
            maxWidth: "90%",
            overflowX: "auto",
            color: "var(--bs-primary)",
            zIndex: "1000",
            marginTop: "-2.0rem",
            marginLeft: "1rem",
            position: "relative",
          }}
        >
          {ticketStatus?.map(
            (
              status: {
                label: string;
                statusUniqueId: string;
                count: number;
                type?: number;
              },
              index: number,
            ) => {
              return (
                <div
                  onClick={() => {
                    if (status.count === 0 || isLoading) {
                      return; // Prevent click action if count is 0 or loader is active
                    }
                    const newurl = new URL(window.location.href);
                    newurl.searchParams.set(
                      "type",
                      (status?.type as number).toString(),
                    );
                    window.history.pushState({}, "", newurl.toString());
                    setFilterParams({
                      ...filterParams,
                      ticketViewId: status?.type,
                      ticketStatusUniqueId: status.statusUniqueId,
                    });
                  }}
                  style={{
                    cursor: status.count === 0 ? "not-allowed" : "pointer", // Show not-allowed cursor if count is 0 or loader is active
                    padding: "4px 15px",
                    display: "flex",
                    borderRadius: "1px",
                    fontFamily:
                      filterParams?.ticketViewId === status?.type
                        ? "Montserrat-SemiBold"
                        : "Montserrat-Medium",
                    color:
                      filterParams?.ticketViewId === status?.type
                        ? "#333333"
                        : "var(--bs-primary)",
                    background:
                      filterParams?.ticketViewId === status?.type
                        ? "#fff"
                        : "transparent",
                    opacity: status.count === 0 ? 0.5 : 1, // Dim the style if count is 0 or loader is active
                  }}
                >
                  <div style={{ width: "max-content" }}>{status.label}</div>
                  <div
                    style={{
                      marginLeft: "1.5rem",
                    }}
                  >
                    <Badge
                      count={status.count}
                      showZero
                      style={{ background: "#e7b000" }}
                    />
                  </div>
                </div>
              );
            },
          )}
        </div>
      ) : null}

      <div className="pageBody">
        <PageHeader
          icon={<IdcardOutlined />}
          title={`${filterParams?.totalRows} Total Tickets`}
          size="large"
        >
          {/* MOVED ON DEDICATED REPORT LIST */}
          {/* {Utils.isUserHasAccess(
            context?.user?.privilegeList,
            ePrivileges.REPORTDOWNLOAD
          ) ? (
            <CustomDrawer
              trigger={
                <Button disabled={isLoading} type="primary">
                  Reports
                </Button>
              }
              component={ReportForm} // Passing DealerForm component
              title="Reports"
              size="default"
            />
          ) : null} */}
          {filterParams.ticketViewId === eTICKETTYPE.ALL ||
          filterParams.ticketViewId === eTICKETTYPE.CLOSE ? (
            <div className={styles.rangeWrapper}>
              <span className={styles.label}>Created between</span>

              <RangePicker
                maxDate={dayjs(new Date())}
                allowClear={false}
                className={styles.customRangePicker}
                value={[
                  filterParams.fromDate ? dayjs(filterParams.fromDate) : null,
                  filterParams.toDate ? dayjs(filterParams.toDate) : null,
                ]}
                format="DD-MMM-YYYY"
                onChange={(dates: any) => {
                  if (!dates) return;

                  setFilterParams((prev) => ({
                    ...prev,
                    fromDate: dates[0]?.format("DD-MMM-YYYY"),
                    toDate: dates[1]?.format("DD-MMM-YYYY"),
                  }));
                }}
              />
            </div>
          ) : null}

          {Utils.isUserHasAccess(
            (context?.user?.privilegeList as TPrivilege[]) || [],
            ePrivileges.BULKUPLOADREQUEST,
          ) ? (
            <CustomDrawer
              trigger={
                <Button disabled={isLoading} type="primary">
                  Import
                </Button>
              }
              component={BulkUploadTicketForm} // Passing DealerForm component
              componentProps={{
                onRefreshList: async () => {
                  /**
                   * Resets the filter parameters to its default values and refetches the data.
                   * Used as a callback when the user is done with importing a file and wants to go back to the list view.
                   */
                  await fetchTicketStatus(getActiveTab() * 1);
                  // setFilterParams({
                  //   ...defaultFilterParams,
                  //   customerId: filterParams.customerId,
                  // });
                  fetchRecordsInChunks();
                },
              }}
              title="Bulk Upload Form"
              size="default"
            />
          ) : null}
          {Utils.isUserHasAccess(
            (context?.user?.privilegeList as TPrivilege[]) || [],
            ePrivileges.ADDSERVICEREQUEST,
          ) ? (
            <Button
              type="primary"
              onClick={() => onAddEdit(0)}
              disabled={isLoading}
            >
              Create
            </Button>
          ) : null}

          <Input
            placeholder="Filter by keywords"
            value={globalsearchText}
            onChange={(e) => setGlobalSearchText(e.target.value)}
            style={{ width: 200, borderColor: "var(--bs-primary-light)" }}
            prefix={<SearchOutlined />}
          />
          <Tooltip title="Refresh List">
            <ReloadOutlined
              onClick={() => {
                fetchTicketStatus(getActiveTab() * 1);
                fetchRecordsInChunks();
              }}
            />
          </Tooltip>
          <ExportToCSV
            data={exportData}
            headers={exportHeaders}
            fileName={`tickets_${DateUtils.format(new Date())}.csv`}
          />
          <Tooltip title="Reset Filters">
            <FilterOutlined onClick={handleResetAll} />
          </Tooltip>
          <Tooltip title="Configure Columns">
            <OrderedListOutlined onClick={() => setDrawerVisible(true)} />
          </Tooltip>
        </PageHeader>

        <div className="tableWrap">
          <Table<TTicket>
            columns={visibleColumns}
            loading={isLoading}
            dataSource={filteredData}
            // pagination={false}
            // sticky={{ offsetHeader: 64 }}
            // virtual
            pagination={{
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total: number, range: [number, number]) =>
                `Showing ${range[0]}-${range[1]} of ${total} total entries`,
              showSizeChanger: true,
              showQuickJumper: false,
              position: ["bottomLeft"],
            }}
            onChange={handleTableChange}
            sticky
            size="small"
            scroll={{
              x: "max-content",
              y: "calc(100vh - 310px)", // Adjust height dynamically
            }}
          />

          <Drawer
            title="Customize Columns"
            placement="right"
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
            style={{ transition: "transform 0.3s ease-in-out" }}
          >
            <ColumnManager
              columns={draftColumns as any}
              initialColumns={initialColumns as any}
              onDragEnd={handleDragEnd}
              onToggleColumn={toggleColumn}
              onResetColumns={handleResetColumns}
              onSave={handleSaveColumns}
              onCancel={() => setDrawerVisible(false)}
            />
          </Drawer>
        </div>

        {/* modal for ticket timeline or service request history */}
        <CustomModal
          title={`# ${selectedTicket?.serviceRequestNo}` || ""}
          useCustomHeader={true}
          isOpen={isModalVisible}
          isFullScreen={true}
          onOk={() => {}} // Passing the custom function
          onCancel={() => {
            setModalVisible(false);
            setSelectedTicket(null);
          }}
          okText=""
          hideOkButton={true}
          cancelText="Close"
          customColor="lightModal"
        >
          <ServiceRequestHistory
            ticketId={selectedTicket?.id as number}
          ></ServiceRequestHistory>
        </CustomModal>

        {/* additional info for dealer details */}
        <CustomModal
          title={"Dealer Details"}
          // useCustomHeader={true}
          isOpen={isDealerModalVisible}
          isFullScreen={true}
          onOk={() => {}} // Passing the custom function
          onCancel={() => {
            setDealerModalVisible(false);
            setDealerDetails(null);
          }}
          footer={null}
          okText=""
          hideOkButton={true}
          hideCancelButton={true}
          cancelText="Cancel"
          width="40%"
          bodyPadding="0px"
        >
          <div
            style={{
              width: "-webkit-fill-available",
              border: "1px solid #f4f4f4",
              height: "75vh",
              overflow: "scroll",
            }}
          >
            <DealerDetails selectedDealer={dealerDetails} />
          </div>
        </CustomModal>

        {/* Re-assign engineer modal and form */}
        <CustomModal
          title={`Re-assign Engineers for #${selectedTicket?.serviceRequestNo}`}
          isOpen={isReassignOpen}
          disableOk={
            primaryEngineer?.value && selectedTicket?.servicePartnerId
              ? false
              : true
          }
          okText="Apply"
          onOk={async () => {
            // Handle Apply action
            await onReassignEngineer();
            setPrimaryEngineer({ value: null, label: "" });
            setSelectedTicket(null);
            setReassignOpen(false);
          }}
          onCancel={() => {
            setPrimaryEngineer({ value: null, label: "" });
            setSelectedTicket(null);
            setReassignOpen(false);
          }}
        >
          <Form name="register" layout="vertical">
            <Row
              gutter={16}
              className="formRowHeight"
              style={{ marginTop: "1.5rem" }}
            >
              <Col span={24}>
                <Form.Item
                  label={
                    <span className={styles.customLabel}>Service Partner</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please choose service partner",
                    },
                  ]}
                >
                  <Select
                    value={selectedTicket?.servicePartnerId}
                    disabled={true}
                    onChange={(selected: any) => {
                      // setServicePartner(selected);
                      setPrimaryEngineer({ value: null, label: "" });
                    }}
                    placeholder="Select Service Partner"
                    options={servicePartnerOptions}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16} className="formRowHeight">
              <Col span={24}>
                <Form.Item
                  label={
                    <span className={styles.customLabel}>Primary Engineer</span>
                  }
                >
                  <CustomDropdown
                    isDisabled={selectedTicket?.servicePartnerId ? false : true}
                    endPoint={GetUserList}
                    value={primaryEngineer?.value}
                    selectedName={primaryEngineer?.label}
                    onChange={(selected: any) => {
                      setPrimaryEngineer({
                        label: selected.label,
                        value: selected.value,
                      });
                    }}
                    label=""
                    placeHolder="Select engineer"
                    optionName="displayName"
                    optionId="id"
                    addPaylod={{
                      stakeHolderName: STAKE_HOLDERS.SERVICEPARTNER,
                      orgId: selectedTicket?.servicePartnerId,
                      roleUniqueId: eRoles.SERVICEENGINEER,
                      servicePartnerId: selectedTicket?.servicePartnerId,
                      mappedDealerViewId: eMAPPED_DEALER_VIEW.MAPPEDDEALER,
                      customerId: selectedTicket?.customerId,
                      dealerId: selectedTicket?.dealerId,
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </CustomModal>

        {/* spare approval form */}
        <CustomModal
          title={`Spare Review for #${selectedTicket?.serviceRequestNo}`}
          isOpen={isSpareApprovalModalVisible}
          disableOk={true}
          hideCancelButton={true}
          hideOkButton={true}
          isFullScreen
          okText="Submit"
          onOk={async () => {
            console.log("OK Pressed");
          }}
          onCancel={() => {
            setSpareApprovalModalVisible(false);
          }}
        >
          <SparePartsTable
            ticketId={selectedTicket?.id as number}
            dealerId={selectedTicket?.dealerId as number}
            onClose={() => setSpareApprovalModalVisible(false)}
            onRefreshList={async () => {
              await fetchTicketStatus(getActiveTab() * 1);
              // setFilterParams({
              //   ...filterParams,
              //   ticketViewId: getActiveTab(),
              // });
              await fetchRecordsInChunks();
            }}
          />
        </CustomModal>

        {/* to establish the engineer mapping for unassign or new dealer */}
        <CustomModal
          title="Configure Engineers"
          isOpen={isAssignMappingFormVisible}
          disableOk={
            selectedTicket?.servicePartnerId &&
            primaryEngineer?.value &&
            secondaryEngineer?.value &&
            serviceEscalation?.value &&
            serviceCordinator?.value
              ? false
              : true
          }
          okText="Apply"
          onOk={() => onApplyConfiguration()} // Passing the custom function
          onCancel={() => {
            setPrimaryEngineer({ value: null, label: "" });
            setSecondaryEngineer({ value: null, label: "" });
            setServiceEscalation({ value: null, label: "" });
            setServiceCordinator({ value: null, label: "" });
            // setServicePartner(null);
            toggleAssignMappingForm(false);
          }}
        >
          <MappingForm
            servicePartner={selectedTicket?.servicePartnerId ?? null}
            customerId={selectedTicket?.customerId as number}
            primaryEngineer={primaryEngineer}
            secondaryEngineer={secondaryEngineer}
            serviceEscalation={serviceEscalation}
            serviceCordinator={serviceCordinator}
            servicePartnerOptions={servicePartnerOptions}
            // activeUser={activeUser}
            setPrimaryEngineer={setPrimaryEngineer}
            setSecondaryEngineer={setSecondaryEngineer}
            setServiceEscalation={setServiceEscalation}
            setServiceCordinator={setServiceCordinator}
            // setServicePartner={setServicePartner}
            disableServicePartner={true}
          />
        </CustomModal>

        <CustomModal
          title="Confirm Delete"
          isOpen={isDeleteModalVisible}
          onOk={handleDeleteOk}
          onCancel={() => handleDeleteCancel()}
          okText="Yes"
          cancelText="No"
          cusHeader={true}
        >
          <p>
            Are you about to delete <b>{selectedTicket?.serviceRequestNo}</b>?
          </p>
        </CustomModal>
      </div>
    </>
  );
}
